import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://d2b13ba1e18d47b3a82e2eee380480ca@o4503930483638272.ingest.sentry.io/4504444529803264',
  environment: process.env.NODE_ENV,
  tracesSampleRate: 1.0,
  sampleRate: 0.5,
  integrations: [new BrowserTracing()],
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

//2020-12-28 TroubleShooting
//could not find a declaration file for module 'react'
//npm install --save @types/react @types/react-dom
